export default {
  // Texte des Onboarding-Rundgangs. Welche Schritte erscheinen, entscheidet services/onboardingTour.ts
  // anhand der Funktionspakete des Tenants und der Rechte des Benutzers. Hier stehen nur die Inhalte.
  //
  // Die Schritte sind zu Kapiteln gruppiert: ein Kapitel ist eine Funktion, und wer sie nicht nutzt,
  // überspringt sie am Stück. Die Kapitelnamen stehen unter `chapter.*`.
  //
  // Zum Ton: kurze Hauptsätze, keine Gedankenstriche, keine Doppelpunkt-Konstruktionen. Wer den
  // Rundgang sieht, kennt das Produkt noch nicht und liest nebenbei. Lieber ein Satz mehr als ein
  // verschachtelter.
  action: {
    begin: "Rundgang starten",
    later: "Später",
    next: "Weiter",
    back: "Zurück",
    replay: "Nochmal ansehen",
    skip: "Überspringen",
    finishSteps: "Fast geschafft",
    done: "Los geht's",
  },
  progress: "Schritt {current} von {total}",
  aria: {
    dialog: "Onboarding-Rundgang",
  },
  // Beschriftungen der Wiedergabesteuerung auf dem Clip. Nur für Screenreader, auf dem Schirm sind
  // es Icons und "2×".
  video: {
    back: "5 Sekunden zurück",
    forward: "5 Sekunden vor",
    speed: "Wiedergabegeschwindigkeit umschalten",
  },
  welcome: {
    title: "Willkommen bei Lewara, {name}!",
    text: "Schön, dass Sie da sind. In ein paar kurzen Videos zeigen wir Ihnen, wie Lewara funktioniert. Danach können Sie sofort loslegen.",
    length: "{count} kurze Videos, etwa {minutes} Minuten",
  },
  outro: {
    eyebrow: "Geschafft",
    title: "Sie sind startklar",
    text: "Das waren die wichtigsten Funktionen. Am besten legen Sie jetzt mit Ihren Stammdaten los. Den Rundgang können Sie jederzeit noch einmal ansehen.",
    // Bildunterschrift unter dem kurzen Clip, der genau diesen Klick zeigt.
    hint: "Oben rechts im Hilfe-Menü",
  },
  // Sammelhinweis am Ende, nur wenn dem Tenant mindestens ein Funktionspaket fehlt. Bewusst allgemein
  // formuliert: manche Pakete gibt es nur im höheren Tarif, andere als Zusatzfunktion.
  upsell: {
    text: "Weitere Funktionen gibt es in den höheren Tarifen und als Zusatzfunktion.",
    cta: "Tarif ändern",
  },
  chapter: {
    basics: "Stammdaten",
    projects: "Projekte",
    hourlywagereport: "[[hwr.pl]]",
    constructionreport: "[[cr.pl]]",
    planning: "Personalplanung",
    costs: "Nachkalkulation",
    invoicing: "Abrechnung",
  },
  step: {
    stammdaten: {
      title: "Einmal anlegen, überall nutzen",
      text: "Ihre Mitarbeiter, Materialien, Maschinen und Kategorien legen Sie an einer Stelle an. Danach können Sie sie überall auswählen. In Projekten, in Berichten und auf Rechnungen.",
    },
    projekt: {
      title: "Alles läuft über das Projekt",
      text: "Im Projekt stehen Auftrag, Kunde und Termine. Dazu ordnen Sie die Mitarbeiter, Maschinen und Materialien zu, die dort gebraucht werden. Genau diese Auswahl bekommt Ihr Team später auf der Baustelle angezeigt.",
    },
    stundenlohnbericht: {
      title: "Erfassen, was abgerechnet wird",
      text: "Für jeden Bereich gibt es einen eigenen Reiter. Personal, Maschinen, Material und zusätzliche Leistungen. Die Stunden werden automatisch summiert. Den fertigen Bericht drucken Sie als PDF und lassen ihn vom Kunden unterschreiben.",
    },
    bautagesbericht: {
      title: "Den Bautag festhalten",
      text: "Hier tragen Sie Schichten, Team, Geräte und besondere Vorkommnisse ein. Das Wetter holt Lewara automatisch für die Adresse der Baustelle. Zu drei Uhrzeiten, wie es die Bauabnahme erwartet, und dazu Stunde für Stunde über die ganze Schicht.",
    },
    personalplanung: {
      title: "Wer ist wann wo",
      text: "Ziehen Sie Ihre Mitarbeiter einfach auf ein Projekt. Doppelbelegungen und Abwesenheiten sind farbig markiert, die Auslastung sehen Sie direkt darunter. So planen Sie niemanden ein, der gar nicht da ist.",
    },
    nachkalkulation: {
      title: "Kosten im Blick behalten",
      text: "Jeder Bericht, den Sie erfassen, wird automatisch auf das Projekt gebucht. In Heatmap, Verlauf und Analyse sehen Sie, wohin das Geld fließt und wie sich Ihre Marge entwickelt. Sie müssen nicht bis zur Schlussrechnung warten.",
    },
    abrechnung: {
      title: "Aus Berichten wird eine Rechnung",
      text: "Wählen Sie Projekt und Zeitraum, markieren Sie die Berichte und fertig. Der Assistent erstellt daraus eine Rechnung mit Ihrem Logo, aufgeschlüsselt nach Personal, Maschinen und Material. Als PDF, direkt zum Versenden.",
    },
  },
}
